import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/park/coupon/used/page', Object.assign({}, options, { params }));

export const getDiscountAmount = (params, options) =>
  request.get('/api/v4ward/park/coupon/used/totalAmount', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/park/coupon/used/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/coupon/used/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/coupon/used/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/park/coupon/used/submit', params,options);
